import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';

import { objectSnakeCaseToCamelCase } from '../../../common/utils/general';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    blockedDates: [],
    itemsCategoryList: [],
    warehouseRental: {
      id: null,
      token: null,
      volume: null,
      desiredLocation: null,
      startRental: null,
      canMoveItems: true,
      stateZoneId: null,
      indefiniteStartRental: null
    },
    client: {
      id: null,
      name: null,
      email: null,
      cellphone: null,
      acceptTermsAndConditions: true,
      cellphoneCountryCode: null,
      cellphoneCountryCodeName: null
    },
    warehouseListItems: [],
    addressConfig: {
      stateZoneId: null,
      googleOptionSelected: null,
    },
    countryInformation: {
      id: null,
      name: null,
      iso: null,
      latitude: null,
      longitude: null,
      comuneName: null,
    }
  },

  getters: {
    isDisabledDate: state => {
      return date => {
        return (
          !moment(date).isValid() ||
          new Date() >= date ||
          state.blockedDates.includes(moment(date).format('YYYY-MM-DD')) ||
          date >= new Date(new Date().setFullYear(new Date().getFullYear() + 1)) ||
          moment(date).weekday() === 0
        );
      }
    },
  },

  mutations: {
    setWarehouseRental(state, payload) {
      state.warehouseRental = { ...state.warehouseRental, ...payload };
    },

    setClient(state, payload) {
      state.client = { ...state.client, ...payload };
    },

    setItemsCategoryList(state, payload) {
      state.itemsCategoryList = payload;
    },

    setWarehouseListItems(state, payload) {
      state.warehouseListItems = payload;
    },

    setAddressConfig(state, payload) {
      state.addressConfig = { ...state.addressConfig, ...payload };
    },

    setBlockedDates(state, payload) {
      state.blockedDates = payload;
    },

    setCountryInformation(state, payload) {
      state.countryInformation = { ...state.countryInformation,
        ...objectSnakeCaseToCamelCase(payload) };
    }
  }
});
